<template>
  <div>
    <div class="header">
      <v-btn color="amber" @click="toWebEx">{{ btnExplain }}</v-btn>
    </div>
    <Post type="form" :isExpert="isExpert" />
  </div>
</template>

<script>
import Post from "@/components/molecules/Post.vue"
export default {
  data: function() {
    return {
      isExpert: false,
    }
  },
  components: {
    Post,
  },
  methods: {
    toWebEx() {
      this.isExpert = !this.isExpert
    },
  },
  computed: {
    btnExplain() {
      return this.isExpert
        ? "WebExpertコース以外の方はこちら"
        : "WebExpertコースの方はこちら"
    },
  },
}
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: flex-end;
}
</style>
